import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Client } from "../../api-client";
import { TABLE_ROWS_COUNT } from "../../../shared/constants";
import {  API_CREATE_VENDOR, API_DELETE_DEPARTMENT, API_GET_VENDOR_LIST, API_UPDATE_VENDOR } from "../../../shared/routes/private.routes";

const config = {
  name: "vendor",
};

export const getVendorList: any = createAsyncThunk(
  `${config.name}/getVendorList`,
  async ({params, body}: any) => {
    return Client.post(API_GET_VENDOR_LIST, body, {params});
  }
);

export const createVendor: any = createAsyncThunk(
  `${config.name}/create-vendors`,
  async (formData: FormData) => {
    return Client.post(API_CREATE_VENDOR, formData);
  }
);

export const deleteVendor: any = createAsyncThunk(
  `${config.name}/delete-vendor`,
  async (vendorId: string) => {
    return Client.delete(API_DELETE_DEPARTMENT+`${vendorId}`);
  }
);

export const updateVendorById: any = createAsyncThunk(
  `${config.name}/update-vendor`,
  async ({ vendorId, formData }: { vendorId: string, formData: FormData }) => {
    const url = API_UPDATE_VENDOR + `${vendorId}`;
    return Client.put(url, formData);
  }
);

export const vendorReducer = createSlice({
  name: config.name,
  initialState: {
    loadingVendor: false as any,
    vendorList: [] as any, 
    filters: {} as any, 
    pagination: {page: 0, limit: TABLE_ROWS_COUNT, total: 0}
  },
  reducers: {
    resetVendor: (state) => {
      state.loadingVendor = false;
      state.vendorList = [];
      state.filters = {};
      state.pagination = {page: 0, limit: TABLE_ROWS_COUNT, total: 0};
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getVendorList.pending, (state) => {
        state.loadingVendor = true;
        state.vendorList = [] as any;
      })
      .addCase(getVendorList.fulfilled, (state, action) => {
        state.loadingVendor = false;
        state.vendorList = action?.payload?.data?.data as any;
        state.pagination = {page: action?.payload?.data?.page, limit: action?.payload?.data?.limit, total: action?.payload?.data?.total}
      })
      .addCase(getVendorList.rejected, (state) => {
        state.loadingVendor = false;
        state.vendorList = [] as any;
      })
  },
});

export const { resetVendor } = vendorReducer.actions;
export default vendorReducer.reducer;
